import {VisitAPIDataSource} from '../api/VisitAPIDataSource';
import {mapVisitStatisticsDTOToModel} from '../mappers/visit.mapper';
import {VisitStatistics} from '../models/visit.model';

export class GetVisitsOverviewUseCase {
  async execute (): Promise<VisitStatistics> {
    try {
      const dto = await VisitAPIDataSource.getOverview();
      return mapVisitStatisticsDTOToModel(dto);
    } catch (error) {
      throw error;
    }
  }
}
